export enum RealTimeEventType {
  AppointmentAdded = 'AppointmentAdded',
  AppointmentUpdated = 'AppointmentUpdated',
  AppointmentOrderChanged = 'AppointmentOrderChanged',
  UserNotificationReceived = 'UserNotificationReceived',
  UserTaskAdded = 'UserTaskAdded',
  UserMessageAdded = 'UserMessageAdded',
  PatientMessageAdded = 'PatientMessageAdded',
  PatientAdded = 'PatientAdded',
  InvoiceAdded = 'InvoiceAdded'
}
